import React, { useState, useEffect } from 'react';
import LicenceItem from './LicenceItem';
import { Link } from 'react-router-dom';
import { base_url } from '../../Api/Api';
import Pagination from '@material-ui/lab/Pagination';
import SkltnLicence from './SkltnLicence';
import Button from '@material-ui/core/Button';

const Licence = (props) => {

    const [state, setState] = useState({
        licenses: [],
        minPaginate: 0,
        maxPaginate: 10,
        countPaginate: 0,
        statusCards: false
    });

    useEffect(() => {

        window.scrollTo(0, 0)

        base_url.get(`my_licenses`)
            .then(response => {
                let tempData = response.data
                let countPaginate = Math.ceil(tempData.length / 9);
                setState({
                    ...state,
                    licenses: tempData,
                    statusCards: response.data.length == 0,
                    countPaginate: countPaginate
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })

    }, [])

    const handleChange = (event, value) => {
        setTimeout(() => {
            window.scrollTo(0, 80)
        }, 100);
        setState({
            ...state,
            minPaginate: (value * 10) - 10 <= 0 ? 0 : (value * 10) - 10,
            maxPaginate: value * 10
        })
    };

    return (
        <div className="licence">
            <div className="contain">
                <div className="licence-body">
                    <div className="backward">
                        <span>گواهینامه‌های من</span>
                        <Button
                            variant="contained"
                            onClick={() => props.history.goBack()} >
                            بازگشت <i className="icon-arrow-down-sign-to-navigate-fill"></i>
                        </Button>
                    </div>
                    <div className="body">
                        {state.licenses.length == 0 ?
                            state.statusCards ?
                                <span className="no-content">اطلاعاتی وجود ندارد</span>
                                :
                                <SkltnLicence />
                            :
                            state.licenses.slice(state.minPaginate, state.maxPaginate).map((info, index) => {
                                return <LicenceItem
                                    key={info.id}
                                    data={info} />
                            })}
                        {state.licenses.length <= 9 ? null :
                            <Pagination
                                count={state.countPaginate}
                                onChange={handleChange} />
                        }
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Licence;